
module.exports = {

  ROOT_ITEM: {
    id: -1,
    text: 'root',
    expanded: true,
    root: true
  },


}
